import { Loading } from '@topconagriculture/react-components';
import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useAlertQuery } from '../../../api/alert/useAlertQuery';
import { useDashboardConfig } from '../../../hooks/useDashboardContext';
const useStyles = makeStyles((theme) => ({
    alertWidgetContent: {
        padding: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: '100%',
        cursor: 'pointer',
    },
    textBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '50%',
    },
    highPriority: {
        width: '100%',
        borderRadius: '4px',
        boxShadow: `0 0 2px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 ${theme.color.error.main}`,
        marginBottom: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90px',
        maxHeight: '90px',
        '& > img': {
            marginRight: '10px',
        },
    },
    highPriorityNumber: {
        float: 'left',
        fontSize: 42,
        fontWeight: theme.font.weight.normal,
        marginRight: '10px',
    },
    highPriorityText: {
        float: 'right',
        lineHeight: '15px',
        paddingTop: '14px',
        width: '50%',
    },
    mediumPriority: {
        width: 'calc(50% - 10px)',
        float: 'left',
        borderRadius: '4px',
        boxShadow: `0 0 2px 0 rgba(0,0,0,0.12), 0 0 3px 0 #FFFC62`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90px',
        maxHeight: '90px',
    },
    lowPriority: {
        width: '50%',
        float: 'right',
        borderRadius: '4px',
        boxShadow: `0 0 2px 0 rgba(0,0,0,0.12), 0 0 3px 0 ${theme.color.primary.main}`,
        marginLeft: '10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90px',
        maxHeight: '90px',
    },
    priorityNumber: {
        float: 'left',
        fontSize: '24px',
        fontWeight: 400,
        marginRight: '10px',
    },
    priorityText: {
        float: 'right',
        fontSize: '10px',
        lineHeight: '10px',
        paddingTop: '7px',
        display: 'flex',
        alignItems: 'center',
        width: '50%',
    },
}));
const AlertWidget = () => {
    const { data: alertStatus, isLoading } = useAlertQuery();
    const classes = useStyles();
    const { t } = useTranslation();
    const { ALARMS_VIEW_MORE_LINK, RESOURCES_BASE_URL } = useDashboardConfig();
    return (React.createElement(Loading, { isLoading: isLoading },
        React.createElement("div", { className: classes.alertWidgetContent, onClick: () => window.open(ALARMS_VIEW_MORE_LINK, '_BLANK') },
            React.createElement("div", { className: classes.highPriority },
                React.createElement("img", { src: `${RESOURCES_BASE_URL}/assets/images/dashboard/icons/alert_high.svg`, alt: "Alert high" }),
                React.createElement("div", { className: classes.textBox },
                    React.createElement("div", { className: classes.highPriorityNumber }, (alertStatus === null || alertStatus === void 0 ? void 0 : alertStatus.HIGH) || 0),
                    React.createElement("div", { className: classes.highPriorityText }, t('widget:alert:high_priority')))),
            React.createElement("div", { className: classes.mediumPriority },
                React.createElement("img", { src: `${RESOURCES_BASE_URL}/assets/images/dashboard/icons/alert_medium.svg`, alt: "Alert medium" }),
                React.createElement("div", { className: classes.textBox },
                    React.createElement("div", { className: classes.priorityNumber }, (alertStatus === null || alertStatus === void 0 ? void 0 : alertStatus.MEDIUM) || 0),
                    React.createElement("div", { className: classes.priorityText }, t('widget:alert:medium_priority')))),
            React.createElement("div", { className: classes.lowPriority },
                React.createElement("img", { src: `${RESOURCES_BASE_URL}/assets/images/dashboard/icons/alert_low.svg`, alt: "Alert low" }),
                React.createElement("div", { className: classes.textBox },
                    React.createElement("div", { className: classes.priorityNumber }, (alertStatus === null || alertStatus === void 0 ? void 0 : alertStatus.LOW) || 0),
                    React.createElement("div", { className: classes.priorityText }, t('widget:alert:low_priority')))))));
};
export default AlertWidget;
//# sourceMappingURL=AlertWidget.js.map